import { TweenLite } from 'gsap';

const header = document.querySelector('.site-header');
const actionBar = document.querySelector('.action-bar');
let actionBarStart = actionBar !== null ? actionBar.offsetTop - header.offsetHeight : null;
const actionBarInner = actionBar !== null ? actionBar.children[0] : null;
const actionBarItems = document.getElementsByClassName('action-bar--item');
const selected = document.querySelector('.action-bar-mobile--selected');
const actionBarItemsWrap = document.querySelector('.action-bar--items');
const bannerNotification = document.querySelector('.bannerNotification.banner-isSticky-true');

const versionConfirmButtons = document.querySelectorAll(
  '.personalisationModal input[class*="-confirm-button"]',
);
if (versionConfirmButtons.length > 0) {
  versionConfirmButtons.forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(() => {
        actionBarStart = actionBar !== null ? actionBar.offsetTop - header.offsetHeight : null;
      }, 250);
    });
  });
}

const docReady = fn => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

const handleActionBar = () => {
  for (let i = 0; i < actionBarItems.length; i += 1) {
    actionBarItemsWrap.append(actionBarItems[i]);
  }

  const actionBarButtons = document.querySelector('.action-bar--buttons');
  if (actionBarButtons !== null && actionBarItems.length > 0) {
    const actionBarParent = actionBarButtons.closest('.action-bar');
    actionBarParent.classList.add('action-bar--has-buttons');
  }
};

const handleSelected = target => {
  if (selected.textContent !== target.textContent) {
    selected.textContent = target.textContent;
  }
};

const changeItems = e => {
  const { target } = e;
  const parent = target.parentNode;

  if (target.classList.contains('active')) {
    return;
  }

  parent.querySelectorAll('[aria-selected="true"]').forEach(t => {
    t.classList.remove('active');
    t.setAttribute('aria-selected', 'false');
  });

  target.classList.add('active');
  target.setAttribute('aria-selected', 'true');
  handleSelected(target);
};

const handleMobileDropdown = () => {
  selected.addEventListener('click', () => {
    let pressed = 'true';
    if (selected.getAttribute('aria-pressed') === 'true') {
      pressed = 'false';
    }
    selected.classList.toggle('active');
    selected.setAttribute('aria-pressed', pressed);
    actionBarItemsWrap.classList.toggle('opened');
  });
};

const handleItemClick = e => {
  e.preventDefault();

  const { target } = e;
  if (target.hash !== '') {
    const sections = document.querySelectorAll(`[id="${target.hash.substring(1)}"]`);
    let sectionToScroll = null;
    sections.forEach(section => {
      if (section.offsetTop !== 0) {
        sectionToScroll = section;
      }
    });

    let additionalOffset = -80;
    if (actionBar.classList.contains('fixed')) {
      additionalOffset = 20;
    }

    if (sectionToScroll !== null && header !== null) {
      TweenLite.to(window, 0.6, {
        scrollTo: {
          y: sectionToScroll.offsetTop,
          offsetY: header.offsetHeight + actionBar.offsetHeight + additionalOffset,
        },
      });

      if (actionBarItemsWrap.classList.contains('opened')) {
        selected.classList.remove('active');
        selected.setAttribute('aria-pressed', 'false');
        actionBarItemsWrap.classList.remove('opened');
      }
    }
  }
};

const handleItemHighlight = () => {
  const sections = document.querySelectorAll('section');
  const scrollPosition = window.scrollY;

  sections.forEach(section => {
    if (section.offsetTop === 0) {
      return;
    }

    const sectionStart = section.offsetTop - 150;
    const sectionBottom = section.offsetTop + section.offsetHeight + actionBar.offsetHeight;
    const actionBarItem = document.querySelector(`.action-bar--item[href="#${section.id}"]`);

    if (actionBarItem !== null && !actionBarItem.classList.contains('active')) {
      if (scrollPosition > sectionStart && scrollPosition < sectionBottom) {
        actionBarItem.classList.add('active');
        actionBarItem.setAttribute('aria-selected', 'true');
        handleSelected(actionBarItem);

        actionBarItems.forEach(item => {
          if (item !== actionBarItem && item.classList.contains('active')) {
            item.classList.remove('active');
            item.setAttribute('aria-selected', 'false');
          }
        });
      }
    }
  });
};

const handleSticky = () => {
  const scrollPosition = window.scrollY;
  actionBarStart = actionBar.offsetTop - header.offsetHeight;

  let bannerNotificationLink = null;
  if (bannerNotification !== null) {
    bannerNotificationLink = bannerNotification.querySelector('.scrolled');
  }

  if (scrollPosition > 0 && scrollPosition >= actionBarStart) {
    if (!actionBarInner.classList.contains('fixed')) {
      actionBarInner.classList.add('fixed');

      if (bannerNotificationLink !== null) {
        bannerNotificationLink.classList.add('with-action-bar');
      }
    }
  } else if (actionBarInner.classList.contains('fixed')) {
    actionBarInner.classList.remove('fixed');

    if (bannerNotificationLink !== null) {
      bannerNotificationLink.classList.remove('with-action-bar');
    }
  }
};

docReady(() => {
  if (actionBar !== null) {
    handleSticky();

    handleActionBar();

    handleSelected(actionBarItems[0]);

    handleMobileDropdown();

    handleItemHighlight();

    actionBarItems.forEach(item => {
      item.addEventListener('click', e => {
        changeItems(e);
        handleItemClick(e);
      });
    });

    window.addEventListener('scroll', handleItemHighlight);
    window.addEventListener('scroll', handleSticky);

    window.addEventListener('load', handleItemHighlight);

    const mqFromMobile = window.matchMedia('(min-width: 540px)');
    window.addEventListener('resize', () => {
      if (mqFromMobile.matches && actionBarItemsWrap.classList.contains('opened')) {
        actionBarItemsWrap.classList.remove('opened');
        selected.classList.remove('active');
        selected.setAttribute('aria-pressed', 'false');
      }
    });
  }
});
